module.exports = __webpack_public_path__ + "img/LOST-V.c4cc4d09.jpg";